import { SuperAdminService } from "services/superAdminService";

class VendorsSAService extends SuperAdminService<any> {
  constructor() {
    super("vendors");
  }
}
export default new VendorsSAService();
